import { useRef, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { FileText, Loader2, Check } from "lucide-react";

export const FileUpload = ({ value, filename, onChange, testid = "file-upload" }) => {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const handleFile = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload-file", fd);
      onChange(data.path, data.filename);
      toast.success("File uploaded 💛");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Upload failed.");
    } finally { setBusy(false); }
  };

  let statusIcon = <FileText className="h-4 w-4" />;
  if (busy) statusIcon = <Loader2 className="h-4 w-4 animate-spin" />;
  else if (value) statusIcon = <Check className="h-4 w-4 text-[#8E9A86]" />;

  let buttonLabel = "Upload PDF / printable";
  if (busy) buttonLabel = "Uploading…";
  else if (value) buttonLabel = "Replace file";

  return (
    <div data-testid={testid}>
      <button type="button" onClick={() => inputRef.current?.click()} disabled={busy} data-testid={`${testid}-btn`}
        className="w-full inline-flex items-center justify-center gap-2 border border-dashed border-[#8E9A86] text-[#3A3632] rounded-lg py-3 text-sm font-medium hover:bg-[#FAF7F2] transition-colors disabled:opacity-60">
        {statusIcon}
        {buttonLabel}
      </button>
      {value && <p className="text-xs text-[#6B655F] mt-1.5 truncate">📄 {filename || "Uploaded file"}</p>}
      <input ref={inputRef} type="file" accept="application/pdf,application/zip,image/*" className="hidden"
        onChange={(e) => handleFile(e.target.files?.[0])} data-testid={`${testid}-input`} />
    </div>
  );
};
